"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogHolder = void 0;
var tsyringe_1 = require("tsyringe");
var DialogHolder = /** @class */ (function () {
    function DialogHolder() {
        this.cmps = [];
    }
    DialogHolder.prototype.setListener = function (listener) {
        this.listener = listener;
    };
    DialogHolder.prototype.removeListener = function () {
        delete this.listener;
    };
    DialogHolder.prototype.updateListener = function () {
        if (this.listener != null) {
            this.listener(this.cmps);
        }
    };
    DialogHolder.prototype.push = function (cmp) {
        this.cmps.push({ id: Math.random().toString(36), element: cmp });
        this.updateListener();
    };
    DialogHolder.prototype.pop = function (cmp) {
        // if (this.cmps.includes(cmp)) {
        var pos = this.cmps.findIndex(function (item) { return item.element === cmp; });
        if (pos >= 0) {
            this.cmps.splice(pos, 1);
            this.updateListener();
        }
        // }
    };
    DialogHolder = __decorate([
        tsyringe_1.singleton()
    ], DialogHolder);
    return DialogHolder;
}());
exports.DialogHolder = DialogHolder;
